import { concat } from '@ember/helper';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import t from 'ember-intl/helpers/t';
import ForcJournalEventBaseComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import PublicComment from 'parog-web/components/layout/medics-web/public-comment';
import capitalize from 'parog-web/helpers/capitalize';
import type { Job } from 'parog-web/models/jobs-declared-journal-event';
import JobsDeclaredJournalEvent from 'parog-web/models/jobs-declared-journal-event';

export default class JobsEditionComponent extends ForcJournalEventBaseComponent {
  static override forcDisplayName = 'Socio-professionnel';
  static override fullComponentId = 'lifestyle/jobs-edition-form';
  static override journalEventClass = JobsDeclaredJournalEvent;

  availableKeys = ['jobCoach', 'socialAssistant'];
  commentaryPrefix = 'comment-';
  override journalEventProperties = ['occurredAt', 'jobs'];
  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceOrLastJournalEvent;

  override computePayload() {
    const payload = super.computePayload();
    payload.occurredAt = new Date();

    payload.jobs = this.availableKeys.map(key => {
      if (!this.model[key]) return;

      return {
        key: key,
        comment: this.model[this.getCommentKey(key)]
      };
    });

    return payload;
  }

  getCommentKey(key: string) {
    return this.commentaryPrefix + key;
  }

  override retrieveModel() {
    const model = super.retrieveModel();

    // If there is a previous JE comming from our JournalEventRetrievalStrategies
    // the model should have a behaviours property
    if (model.jobs) {
      // Inject the content of the array in our model
      (model.jobs as Job[]).forEach(job => {
        model[job.key] = true;
        model[this.getCommentKey(job.key)] = job.comment;
      });
    }

    return model;
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        {{#each this.availableKeys as |key|}}
          <div class='field'>
            <Form.Checkbox
              @labelName={{capitalize (t 'lifestyle.job' key=key)}}
              @payloadKey={{key}}
            />
          </div>
          {{#if (changesetGet this.changeset key)}}
            <div class='field'>
              <PublicComment
                @form={{Form}}
                @labelName='Précisions'
                @propertyName={{concat this.commentaryPrefix key}}
              />
            </div>
            <br />
          {{/if}}
        {{/each}}
      </:content>
    </Provider>
  </template>
}
